import { render, staticRenderFns } from "./GuideLink.vue?vue&type=template&id=0219bcc9&scoped=true&"
import script from "./GuideLink.vue?vue&type=script&lang=ts&"
export * from "./GuideLink.vue?vue&type=script&lang=ts&"
import style0 from "./GuideLink.vue?vue&type=style&index=0&id=0219bcc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219bcc9",
  null
  
)

export default component.exports